import { Lookup } from './lookup.model';
import { FilterCriteria } from '../mystudies/add-filter-dialog/shared/filter-criteria.model';

export class StudySearchFilter {
  public studySearchFilterId: number;
  public studySearchStrategyId: number;
  public stepFilterTypeId: number;
  public stepFilterJson?: string;
  public stepResults: number;
  public searchResults: number;
  public displayOrder?: number;
  public isActive = true;
  public isModified?: boolean = false;
  public stepFilterType: Lookup;
  public filter: FilterCriteria;
  public cachedFilterJsonHash: string;
  public stepFilterJsonObject: any;
}
